import { Service } from './service'

export class OwnersService extends Service {
  getOwnerList (data) {
    const res = this._apiRequestBuilder.owner()
      .getByAsset(data)
      .sign(this._keypair)
      .json()
      .get()
    return res
  }
}

export const ownersService = new OwnersService()



// WEBPACK FOOTER //
// ./src/js/services/owners.service.js